export const PERMISSIONS = {
  VIEW: 'AC_INTERNAL_DEBT_VIEW',
  EXPORT: 'AC_INTERNAL_DEBT_EXPORT',
};
